import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { ReportViewerComponent } from "src/app/report-viewer/report-viewer.component";
import { InstituteService } from "src/app/Shared/institute.service";
import { LovService } from "src/app/Shared/lov.service";
import { SMCourseService } from "src/app/Shared/smcourse.service";
import { EmployeeinfohdrService } from "src/app/Shared/employee.service";

@Component({
    selector: 'admissionenquiry',
    templateUrl: 'admissionenquiry.component.html',
})
export class AdmissionenquiryComponent implements OnInit {
    Employee: any;
    Course: any;
    Response: any;
    Entity: any;
    reportUrl: string;
    title = 'Admission Enquiry';

    protected fb: FormBuilder = new FormBuilder();
    public myForm: FormGroup;
    @ViewChild('admissionenquiry') report: ReportViewerComponent;

    async ngOnInit() {
        await this.getEntity();
        await this.getResponse();
    }

    constructor(
        private entityService: InstituteService,
        private lovService: LovService,
        private courseservice: SMCourseService,
        private employeeService: EmployeeinfohdrService,
    ) {
        this.myForm = this.fb.group({
            'entityid': ['', []],
            'code': ['', []],
            'resptypeid': ['', []],
            'courseid': ['', []],
            'assignto': ['', []],
            'stxt': ['', []]
        });
    }

    getAdmissionEnquiry() {
        let entityid;
        let code = 'null';
        let resptypeid;
        let courseid;
        let assignto;
        let stxt = 'null';

        if (this.myForm.controls['entityid'].value) {
            entityid = this.myForm.controls['entityid'].value;
        }

        if (this.myForm.controls['code'].value && this.myForm.controls['code'].value.trim()) {
            code = this.myForm.controls['code'].value.trim();
        }

        if (this.myForm.controls['resptypeid'].value) {
            resptypeid = this.myForm.controls['resptypeid'].value;
        }

        if (this.myForm.controls['courseid'].value) {
            courseid = this.myForm.controls['courseid'].value;
        }

        if (this.myForm.controls['assignto'].value) {
            assignto = this.myForm.controls['assignto'].value;
        }

        if (this.myForm.controls['stxt'].value && this.myForm.controls['stxt'].value.trim()) {
            stxt = this.myForm.controls['stxt'].value.trim();
        }

        this.report.invokeAction = "WebDocumentViewer/AdmissionEnquiry";
        this.reportUrl = "AdmissionEnquiry&api/FOAdmEnquiry/v2/AdmissionEnquiry/" + entityid + "/" + code + "/" + stxt + "/" + resptypeid + "/" + courseid + "/" + assignto;
        this.report.getReportData();
    }

    async getEntity() {
        const dto = await this.entityService.getEntity();
        if (dto.IsSuccess) {
            this.Entity = dto.Data;
        }

        else {
            console.log(dto.Errors);
        }
    }

    async getResponse() {
        const dto = await this.lovService.getResponse();
        if (dto.IsSuccess) {
            this.Response = dto.Data;
        }
        else {
            console.log(dto.Errors);
        }
    }

    async getEntityCourse(entityid) {
        const dto = await this.courseservice.getEntityCourse(entityid);
        if (dto.IsSuccess) {
            this.Course = dto.Data;
        } else {
            console.log(dto.Errors);
        }
    }

    async getEmployee(entityid) {
        const dto = await this.employeeService.GetEmployeeEntity(entityid);
        if (dto.IsSuccess) {
            this.Employee = dto.Data;
        } else {
            console.log(dto.Errors);
        }
    }

    clearfilter() {
        this.myForm.controls['entityid'].setValue(undefined);
        this.myForm.controls['code'].setValue(undefined);
        this.myForm.controls['resptypeid'].setValue(undefined);
        this.myForm.controls['courseid'].setValue(undefined);
        this.myForm.controls['assignto'].setValue(undefined);
        this.myForm.controls['stxt'].setValue(undefined);
    }
}